import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'oidc-react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import InfoCard from './infoCard';
import InfoStatusCard from './InfoStatusCard';
import InfoSystemCard from './infoSystemCard';
import InfoDeviceInsight from './infoDeviceInsight';
import Project from '../../common/Utils/project';
import { LoaderCircle } from 'lucide-react';
import { useTenantSelection } from '../../providers/TenantSelectionProvider';
import api from '../../components/services/apiService';

const DeviceInfoBase = () => {
  const { id } = useParams();
  const [deviceData, setDeviceData] = useState(null);
  const auth = useAuth();
  const { selectedTenantId } = useTenantSelection();

  useEffect(() => {
    const fetchDeviceData = async () => {
      try {
        const token = auth?.userData?.access_token;
        let tenantId = selectedTenantId;
        const response = await api.get(`${Project.api}agentapi/AgentDeviceManagement/${tenantId}/agent-endpoint-details/${id}`);

        const Data = response?.data?.data;
        setDeviceData({ ...Data, agentId: id });
      } catch (error) {
        console.error(`Error fetching groups:`, error);
      }
    };

    if (id) {
      fetchDeviceData();
    }
  }, [auth, id]);
  if (!deviceData || (typeof deviceData === 'object' && Object.keys(deviceData).length === 0)) {
    return (
      <>
        <div className="flex min-h-screen text-white" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
          {/* Sidebar */}
          <Sidebar />

          {/* Right Panel */}
          <div className="flex-1 flex flex-col">
            <div className="min-h-screen flex items-center justify-center text-white">
              <LoaderCircle className="animate-spin w-10 h-10 text-white" />
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="flex min-h-screen text-white" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Right Panel */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <Header title="Device Info" dropdown={2} showBackButton />

        {/* Main Content */}
        <div className="p-4 flex gap-4">
          {/* Left Column: InfoCard + InfoSystemCard */}
          <div className="w-full md:w-2/3 ">
            <Card>
              <InfoCard deviceData={deviceData} />
            </Card>
            <Card>
              <InfoSystemCard deviceData={deviceData} />
            </Card>
          </div>

          {/* Right Column: InfoStatusCard */}
          <div className="w-full md:w-1/3">
            <Card className="flex-1 h-full">
              <InfoStatusCard deviceData={deviceData} />
            </Card>
          </div>
        </div>
        <div className="pl-4 flex gap-4">
          <Card className="flex-1 h-full">
            <InfoDeviceInsight deviceData={deviceData} />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DeviceInfoBase;
